/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-shadow */
export enum ParameterType {
    Value,
    Constant,
    Reserved,
    System
}
